import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_COMPANY_BALANCES_GET_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_COMPANY_BALANCES_GET_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_COMPANY_BALANCES_GET_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/companies/${id}/balances`,
    method: 'GET',
  })
);

export default apiCall;
